import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";

import { ApiService } from "../common/services/api.service";
import { LoaderService } from "./loader/loader.service";

import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from "@angular/material/legacy-progress-spinner";

import { FooterComponent } from "./footer/footer.component";
import { NavbarComponent } from "./navbar/navbar.component";
import { SidebarComponent } from "./sidebar/sidebar.component";
import { LoaderComponent } from "./loader/loader.component";

@NgModule({
  imports: [CommonModule, RouterModule, MatProgressSpinnerModule],
  declarations: [
    FooterComponent,
    NavbarComponent,
    SidebarComponent,
    LoaderComponent,
  ],
  exports: [FooterComponent, NavbarComponent, SidebarComponent,LoaderComponent],
  providers: [
    LoaderService,
    {
        provide: ApiService
    }
]
})
export class ComponentsModule {}
